import { render, staticRenderFns } from "./PtrMenuExpander.vue?vue&type=template&id=4eda49d8&"
import script from "./PtrMenuExpander.vue?vue&type=script&lang=js&"
export * from "./PtrMenuExpander.vue?vue&type=script&lang=js&"
import style0 from "./PtrMenuExpander.vue?vue&type=style&index=0&id=4eda49d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports